import NorthEastIcon from '@mui/icons-material/NorthEast';
import { Box, alpha, lighten } from '@mui/material';

import { DiscoverIcon } from '../../icons';

import { Button } from '../Button';
import { Typography } from '../Typography';

type ParIntelligenceSidebarCtaProps = {
  url: string;
};

export const ParIntelligenceSidebarCta = ({ url }: ParIntelligenceSidebarCtaProps) => (
  <Button
    component='a'
    href={url}
    target='_blank'
    rel='noopener noreferrer'
    aria-label='Open PAR Intelligence in a new tab'
    data-testid='par-intelligence-cta'
    sx={(theme) => ({
      width: '100%',
      mt: 0.5,
      mb: 0,
      height: 52,
      py: 0,
      pl: 1.375,
      pr: 0,
      justifyContent: 'start',
      borderRadius: 2,
      color: 'text.secondary',
      letterSpacing: 0,
      textTransform: 'none',
      '&:hover': {
        background: lighten(theme.palette.background.default, 0.5),
      },
    })}
    fullWidth
  >
    <Box display='flex' alignItems='center' minWidth={0}>
      <DiscoverIcon
        fontSize='small'
        sx={{
          mr: 2,
          flexShrink: 0,
          color: 'text.disabled',
          '& [data-discover-icon-part="body"]': {
            color: (theme) => alpha(theme.palette.text.secondary, 0.72),
          },
          '& [data-discover-icon-part="spark"]': {
            color: 'text.disabled',
          },
        }}
      />
      <Typography
        component='span'
        noWrap
        sx={{
          color: 'text.secondary',
          fontWeight: 500,
          lineHeight: 1.5,
        }}
      >
        PAR Intelligence
        <Box component='sup' sx={{ ml: 0.2, fontSize: '0.58em', lineHeight: 0 }}>
          ®
        </Box>
      </Typography>
    </Box>
    <Box
      sx={{
        ml: 'auto',
        width: 24,
        height: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <NorthEastIcon
        sx={{
          color: 'text.disabled',
          fontSize: 16,
        }}
      />
    </Box>
  </Button>
);
